export class DocumentoEntrada {

    public id: number;
    public codigoDocumento: string;
    public codigoBodega: string;
    public codigoConsorcio: string;
    public codigoSucursal: string;
    public estado: string;
    public referenciaERP: string;
    public fecha: any;
    public codigoCliente: string;
    public dua: string;
    public contenedor: string;
    public referencia1: string;
    public referencia2: string;
    public comentarios: string;
    public movInv: string;
    public factura: string;
    public listaEmpaque: string;
    public lote: string;
    public valorCIF: number;
    public impuestos: number;
    public bultos: number;
    public kilos: number;
    public tipoIngreso: string;
    public nombreProveedor: string;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/documento-entrada.ts